import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { createGenericError } from 'utils'
import { getAccountNotes as getAccountNotesRemote } from '../api'
import { HttpResponseStatusCodes } from '../constants'

export const GET_ACCOUNT_NOTES = 'GET_ACCOUNT_NOTES'
export const GET_ACCOUNT_NOTES_SUCCESS = 'GET_ACCOUNT_NOTES_SUCCESS'
export const GET_ACCOUNT_NOTES_FAILURE = 'GET_ACCOUNT_NOTES_FAILURE'

export const getAccountNotes = (
  dispatch: Dispatch,
  accountNumber: string,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_ACCOUNT_NOTES })
  getAccountNotesRemote(accountNumber)
    .then(({ data: accountNotes }: AxiosResponse) => {
      dispatch({ type: GET_ACCOUNT_NOTES_SUCCESS, accountNotes })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      if (httpResponseStatus === HttpResponseStatusCodes.NotFound) {
        dispatch({ type: GET_ACCOUNT_NOTES_SUCCESS, accountNotes: [] })
      } else {
        createGenericError(error, dispatch, GET_ACCOUNT_NOTES_FAILURE, onError)
      }
    })
}
